import * as React from 'react';
import { ProtectedRoute } from '../../common/components';
import TextBlocksPage from '../screens/TextBlocksPage';

export const ListTextBlocksPagesNavigation = {
    ProjectTextBlocksPage: '/projects/:id/textBlocks'
};

export default () => {
    return <ProtectedRoute component={TextBlocksPage} path={ListTextBlocksPagesNavigation.ProjectTextBlocksPage} />;
};
